import { Singleton } from "util";

@Singleton
class RuntimePersistence {
  _memoryStorage = window.localStorage;

  set(key, value) {
    value = JSON.stringify(value);
    window.localStorage.setItem(key, value);
  }

  unset(key) {
    window.localStorage.removeItem(key);
  }

  get(key) {
    const value = JSON.parse(window.localStorage.getItem(key));
    return value;
  }
}

export default RuntimePersistence;



// WEBPACK FOOTER //
// ./src/core/persistence/runtime.persistence.js